import React from "react";
import styled from "styled-components";
import { Colors } from "./styles/Colors";
import { ProximaNova } from "./typography";
import Breakpoints from "./styles/Breakpoints";

const Wrapper = styled.div`
  display: inline-flex;
  width: 100%;
  max-width: 540px;
  margin: 40px 0;
`;

const Segment = styled.button`
  border: 1px solid ${Colors.webGrey};
  color: ${(props) => (props.active ? Colors.yellow : Colors.greyLight)};
  font-family: ${ProximaNova};
  background: none;
  text-transform: uppercase;
  flex: 1;
  padding: 16px;
  position: relative;
  overflow: hidden;
  margin: 0;
  transition: .15s cubic-bezier(.6,0,.3,1);
  ///////////////////////////// HOVER STATE
  &:hover {
    cursor: ${(props) => (props.active ? 'auto' : 'pointer')};
    color: ${Colors.yellow};
  }
  ///////////////////////////// BACKGROUND SETUP
  &:before {
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: ${Colors.hunter};
    border-radius: 0px 0px 0px 0px;
    transition: .3s cubic-bezier(.6,0,.3,1);
  }
  ///////////////////////////// ICON AND TEXT
  span, svg {
    position: relative;
    display: inline;
    z-index: 1;
    vertical-align: middle;
  }
  span {
    text-transform: uppercase;
    letter-spacing: .1rem;
    font-size: .75rem;
    margin-left: 8px;
    font-weight: 300;
  }
  ///////////////////////////// LEFT BUTTON
  &:first-child {
    border-radius: 32px 0px 0px 32px;
    border-right: none;
    svg {
      width: 24px;
      height: 24px;
    }
    &:before {
      transform: ${(props) => (props.active ? 'translateX(0%)' : 'translateX(100%)')};
      border-radius: ${(props) => (props.active ? '32px 0px 0px 32px' : '0px 0px 0px 0px')}
    }
  }
  ///////////////////////////// RIGHT BUTTON
  &:last-child {
    border-radius: 0px 32px 32px 0px;
    border-left: none;
    svg {
      width: 30px;
      height: 20px;
    }
    &:before {
      transform: ${(props) => (props.active ? 'translateX(0%)' : 'translateX(-100%)')};
      border-radius: ${(props) => (props.active ? '0px 32px 32px 0px' : '0px 0px 0px 0px')}
    }
  }
  ///////////////////////////// SPACING ADJUSTMENT TO FIT ON MOBILE W/O WRAPPING
  @media ${Breakpoints.tablet} {
    padding: 16px 24px;
    span {
      letter-spacing: .15rem;
    }
  }
`;

const Sun = (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <defs />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16.5 12a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM12 1v2M12 21v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M1 12h2M21 12h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4"
    />
  </svg>
);

const Moon = (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
    <defs />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19 10.8A9 9 0 119.2 1a7 7 0 009.8 9.8v0z"
    />
  </svg>
);


export default function SegmentControl({ active, setActive, data }) {
  return (
    <Wrapper>
      <Segment onClick={() => setActive(0)} active={active === 0}>
        {Sun}
        <span>{ `Morning${data.name.includes('Routine') ? ' Routine' : ''}` }</span>
      </Segment>
      <Segment onClick={() => setActive(1)} active={active === 1}>
        {Moon}
        <span>{ `Night${data.name.includes('Routine') ? ' Routine' : ''}` }</span>
      </Segment>
    </Wrapper>
  );
}
